// extracted by mini-css-extract-plugin
module.exports = {"content__tag":"styles_content__tag__QnKis","pulse":"styles_pulse__OuARk","jump":"styles_jump__iDZ_C"};